import React from "react";
import {Form, Input , Radio,Row,Col} from 'antd';
import NHFormItem from '../../common/NHFormItem';
import ViewForm from "./ViewForm";
import { hasAuth} from "../../../utils/NHCore";
const { TextArea } = Input;
const RadioGroup = Radio.Group;

class AuditInitForm extends React.Component {
      constructor(props) {
            super(props);
            this.state = {
                  checkedOptions:[],
                  defaultChecked:[]
            }
      }

      render(){
            const initFormData = this.props.initFormData;
            initFormData['SJLY'] = undefined;
            let formItemLayout = {
                  labelCol: { span: 4 },
                  wrapperCol: { span: 20 },
            };
            return <div>
                  <ViewForm initFormData={initFormData}/>
                  <div style={{display:'none'}}>
                        <NHFormItem id={"pkid"}
                              form={this.props.form}
                              initialValue={initFormData.PKID}>
                              <Input />
                        </NHFormItem>
                  </div>
                  <div style={{display:'none'}}>
                        <NHFormItem id={"blje"}
                              form={this.props.form}
                              initialValue={initFormData.BLJE}>
                              <Input />
                        </NHFormItem>
                  </div>
                  <div style={{display:'none'}}>
                        <NHFormItem id={"xsid"}
                              form={this.props.form}
                              initialValue={initFormData.XSID}>
                              <Input />
                        </NHFormItem>
                  </div>
                  <NHFormItem id={"shzt"} required={true} label={"审核状态"}
                        form={this.props.form} formItemLayout={formItemLayout} initialValue={'1'}>
                        <RadioGroup>
                              <Radio value={'1'}>通过</Radio>
                              <Radio value={'-1'}>不通过</Radio>
                              {hasAuth('zhxg_yxgl_swbl_lstd:cancel') ?<Radio value={'9'}>驳回</Radio>: ''}
                        </RadioGroup>
                  </NHFormItem>
                  <NHFormItem id={"shyj"} label={"审核意见"}
                        form={this.props.form} formItemLayout={formItemLayout}>
                        <TextArea placeholder={'审核意见'} autosize={{minRows:2,maxRows:5}}/>
                  </NHFormItem>
            </div>
      }
}
const AuditForm = Form.create()(AuditInitForm);

export default AuditForm;


// WEBPACK FOOTER //
// ./components/swbl/ynjtLstd/AuditForm.js